const policyIssuanceConstants = {
    PENDING_ISSUANCE : 'Pending Issuance',

    ISSUED : 'Issued',

    REVERTED_TO_PENDING_ISSUANCE : 'Reverted to Pending Issuance',

    REVERTED_TO_BOUND : 'Reverted to Bound'

};

angular.module('gw-um-j2js')
    .constant('policyIssuanceConstants', policyIssuanceConstants);